import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { nextPlayer, nextTurn, incrementScore } from "../../actions";
import axios from "axios";
import socket from "../../socket";
import Button from "../Button";
import ProgressBar from "../ProgressBar";

const QuizCard = ({ room, timer }) => {
	const [choice, setChoice] = useState("");
	const quizData = useSelector((state) => state.quizData);
	const isLoggedIn = useSelector((state) => state.registeredUser.isLoggedIn);
	const dispatch = useDispatch();
	const navigator = useNavigate();

	const handleAnswer = (e) => {
		socket.emit("update trivia", {
			room,
			selectedAnswer: e.target.textContent,
			quizData
		});
	};

	const handleReturn = () => {
		socket.emit("join room", room);
		socket.emit("finish");
	};

	const handleExit = () => {
		navigator("../lobby");
	};

	const handleLeaderBoard = () => {
		navigator("../scores");
	};

	useEffect(() => {
		socket.on("update", (data) => {
			if (
				data.selectedAnswer ===
				data.quizData.trivia[data.quizData.playerIndex].results[
					data.quizData.turnIndex
				].correct_answer
			) {
				setChoice("CORRECT");
				data.quizData.trivia[data.quizData.playerIndex].score++;
				dispatch(incrementScore(data.quizData.trivia));
			} else if (data.selectedAnswer === "TIME") {
				setChoice("TIME");
			} else {
				setChoice("INCORRECT");
			}
			if (
				data.quizData.playerIndex === data.quizData.trivia.length - 1 &&
				data.quizData.turnIndex === data.quizData.trivia[0].results.length - 1
			) {
				const triviaIndex = data.quizData.trivia.findIndex((player) => {
					return (
						player.user === JSON.parse(localStorage.getItem("user")).username
					);
				});
				const score = {
					userId: JSON.parse(localStorage.getItem("user")).userId,
					name: JSON.parse(localStorage.getItem("user")).username,
					noOfQuestions: data.quizData.trivia[triviaIndex].results.length,
					category: data.quizData.category,
					difficulty: data.quizData.difficulty,
					type: data.quizData.type,
					score: data.quizData.trivia[triviaIndex].score
				};
				axios
					.post(`${process.env.REACT_APP_USERS_API_URL}/scores`, score)
					.then((response) => console.log(response))
					.catch((err) => console.log(err));
				if (isLoggedIn) {
					const userScore = {
						noOfQuestions: data.quizData.trivia[triviaIndex].results.length,
						category: data.quizData.category,
						difficulty: data.quizData.difficulty,
						type: data.quizData.type,
						score: data.quizData.trivia[triviaIndex].score
					};
					const config = {
						headers: {
							Authorization: "Bearer " + localStorage.getItem("token")
						}
					};
					axios
						.patch(
							`${process.env.REACT_APP_USERS_API_URL}/auth/update-user`,
							userScore,
							config
						)
						.then((response) => console.log(response))
						.catch((err) => console.log(err));
				}
				socket.emit("leave room", room);
				setTimeout(() => {
					setChoice("END");
				}, 3000);
			} else if (
				data.quizData.playerIndex ===
				data.quizData.trivia.length - 1
			) {
				setTimeout(() => {
					setChoice("");
					dispatch(nextTurn(data.quizData.turnIndex + 1));
					dispatch(nextPlayer(0));
				}, 3000);
			} else {
				setTimeout(() => {
					setChoice("");
					dispatch(nextPlayer(data.quizData.playerIndex + 1));
				}, 3000);
			}
		});
		return () => socket.off("update");
	}, [dispatch, room]);

	useEffect(() => {
		const timerCountdown = setTimeout(() => {
			socket.emit("update trivia", {
				room,
				selectedAnswer: "TIME",
				quizData
			});
		}, Number(timer) * 1000);
		return () => {
			clearTimeout(timerCountdown);
		};
	}, [choice]);

	const renderChoice = (choice) => {
		switch (choice) {
			case "CORRECT":
				return <h1>CORRECT!</h1>;
			case "INCORRECT":
				return <h1>INCORRECT!</h1>;
			case "TIME":
				return <h1>TIME'S UP!</h1>;
			case "END":
				return (
					<>
						<div>
							<div>
								<h1>Scores:</h1>
								{quizData.trivia.map((player) => {
									return (
										<h2>
											{player.user}: {player.score}/{player.results.length}
										</h2>
									);
								})}
								<Button
									text={
										<>
											Return to Room<span aria-hidden></span>
											<span aria-hidden class="cybrBtnGlitch">
												Return to Room
											</span>
										</>
									}
									onClick={handleReturn}
								/>
								<Button
									text={
										<>
											Leaderboard<span aria-hidden></span>
											<span aria-hidden class="cybrBtnGlitch">
												Leaderboard
											</span>
										</>
									}
									onClick={handleLeaderBoard}
								/>
								<Button
									text={
										<>
											Exit<span aria-hidden></span>
											<span aria-hidden class="cybrBtnGlitch">
												Exit
											</span>
										</>
									}
									onClick={handleExit}
								/>
							</div>
						</div>
					</>
				);
			default:
				return (
					<>
						<ProgressBar timer={timer} />
						<div>
							<h1>
								Question {quizData.turnIndex + 1} for{" "}
								{quizData.trivia[quizData.playerIndex].user}
							</h1>
							<h1>
								{
									quizData.trivia[quizData.playerIndex].results[
										quizData.turnIndex
									].question
								}
							</h1>
							{quizData.trivia[quizData.playerIndex].results[
								quizData.turnIndex
							].answers.map((answer) => (
								<p
									id="questionAnswers"
									onClick={(e) => {
										if (
											JSON.parse(localStorage.getItem("user")).username ===
											quizData.trivia[quizData.playerIndex].user
										) {
											handleAnswer(e);
										}
									}}
								>
									{answer}
								</p>
							))}
						</div>
					</>
				);
		}
	};

	return <>{renderChoice(choice)}</>;
};

export default QuizCard;
